import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { appShell as defaultAppShell } from '../../../theme/tokens/semantic';
import { shadows as defaultShadows } from '../../../theme/tokens/shadows';
import useAppShellTheme from './useAppShellTheme';
import {
  createSidebarBrandLayoutSx,
  createSidebarCollapseToggleSx,
  createSidebarIconBoxSx,
  createSidebarIconWrapSx,
  createSidebarLabelSx,
  createSidebarNavButtonSx,
  createSidebarNavIconSx,
  createSidebarNavItemLayoutSx,
  createSidebarRailItemWrapSx,
  createSidebarWidthTransition,
} from '../utils/sidebarTransition';

export default function useSidebarTransition() {
  const theme = useTheme();
  const { appShell, shadows } = useAppShellTheme();
  const sidebar = appShell?.sidebar ?? defaultAppShell.sidebar;
  const shadowTokens = shadows ?? defaultShadows;

  return useMemo(
    () => ({
      widthTransition: createSidebarWidthTransition(theme),
      getLabelSx: (collapsed) => createSidebarLabelSx(theme, collapsed),
      getIconBoxSx: (collapsed) => createSidebarIconBoxSx(theme, collapsed),
      getNavItemLayoutSx: (collapsed, depth = 0) =>
        createSidebarNavItemLayoutSx(theme, collapsed, depth),
      getRailItemWrapSx: () => createSidebarRailItemWrapSx(),
      getBrandLayoutSx: (collapsed) => createSidebarBrandLayoutSx(theme, collapsed),
      getNavButtonSx: (options) => createSidebarNavButtonSx(sidebar, options),
      getNavIconSx: () => createSidebarNavIconSx(),
      getIconWrapSx: () => createSidebarIconWrapSx(),
      getToggleMotionSx: (collapsed) =>
        createSidebarCollapseToggleSx(theme, collapsed, sidebar, shadowTokens),
      sectionCollapseTimeout: theme.transitions.duration.standard,
    }),
    [theme, sidebar, shadowTokens]
  );
}
